import * as Yup from 'yup';
import { PqrDataSfc } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrDataSfc = {
    channelPresentsFailure: '',
    controlEntity: '',
    receptionInstance: '',
    receptionPoint: '',
    hasExpressComplaint: false,
    admission: '',
};

export const validationSchema = Yup.object({
    channelPresentsFailure: Yup.string().required(
        'El canal qué presentó falla es obligatorio'
    ),
    controlEntity: Yup.string().required('El ente de control es obligatorio'),
    receptionInstance: Yup.string().required(
        'La instancia de recepción es obligatoria'
    ),
    receptionPoint: Yup.string().required(
        'El punto de recepción es obligatorio'
    ),
    admission: Yup.string().required('La admisión es obligatoria'),
});
